import React, { useRef, useState } from 'react';
import styles from './profilebody.module.css';
import Myprofile from '../../pages/myprofile/Myprofile';
import { useDispatch, useSelector } from 'react-redux';
import api from '../../../helper/Api';
import axios from 'axios';
import Toastify from '../../../helper/Toastify';
import { updateProfileThunk, deleteProfileImageThunk } from '../../../redux/userSlice';
import { useNavigate } from 'react-router-dom';


const ProfileBody = () => {
    const { user, isLoading } = useSelector((state) => state.user);
    const profileImgRef = useRef();
    const [loading, setLoading] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [imgVersion, setImgVersion] = useState(0); 
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const handleImageChange = async (e) => {
        
        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];
        if (!file || loading) return;
        setLoading(true);
        try {
            if (file) {
                const body = {
                    key: `${Date.now()}_${file.name}`,
                    fileType: file.type,
                    fileName: file.name,
                };
                const { data, status } = await api.getPutSignedUrl(body);

                if (status === 200) {
                    await axios.put(data.data?.preSigned, file, {
                        headers: {
                            "Content-Type": file.type
                        }
                    })
                    const imageUrl = `${data?.data?.url}?v=${Date.now()}`;
                    const values = { ...user, profileImg: imageUrl };
                    dispatch(updateProfileThunk(values));
                    setImgVersion(prev => prev + 1);
                }
            }
        } catch (err) {
            console.log(err);
            Toastify.error("Error uploading file");
        } finally {
            setLoading(false);
            profileImgRef.current && (profileImgRef.current.value = "");
        }
    };

    const deleteImage = async () => {
        if (isDeleted) return;
        setIsDeleted(true);
        try {
            await dispatch(deleteProfileImageThunk());
            setImgVersion(prev => prev + 1);
        } catch (err) {
            console.error("Deletion error:", err);
        } finally {
            setIsDeleted(false);
            profileImgRef.current && (profileImgRef.current.value = "");
        }
    };


    return (
        <Myprofile>
            <div className={styles.profilebodyContainer}>
                <div className={styles.profileheader}>
                    <h2>My Profile</h2>
                </div>
                <div className={styles.profilebodyContent}>
                    <div className={styles.profilebodyDetails}>
                        <label htmlFor="fullName">First Name</label>
                        <input
                            type="text"
                            id="fullName"
                            name="fullName"
                            value={user?.firstName}
                        /*  disabled={!isEditing} */
                        />

                        <label htmlFor="lastName">Last Name</label>
                        <input
                            type="text"
                            id="lastName"
                            name="lastName"
                            value={user?.lastName}
                        /*  disabled={!isEditing} */
                        />

                        <label htmlFor="email">Email</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            value={user?.email}
                        /*  disabled={!isEditing} */
                        />

                        <label htmlFor="phone">Phone Number</label>
                        <input
                            type="tel"
                            id="phone"
                            name="phone"
                            value={user?.phone}
                        /*  disabled={!isEditing} */
                        />

                        <button className={styles.savechanges} onClick={() => navigate('/editprofile')}>Edit</button>
                    </div>

                    <div className={styles.profilebodyImage}>
                        {user?.profileImg ?
                            <img
                                key={imgVersion}
                                src={`${user.profileImg.split('?')[0]}?v=${imgVersion}`}
                                alt="User Avatar"
                                className={styles.avatar}
                            />
                            :
                            <img
                                src="/assets/proimage.jpg"
                                alt="User Avatar"
                                className={styles.avatar}
                            />
                        }

                        <input type="file" style={{ display: 'none' }} name='profileImg' id='profileImg' ref={profileImgRef} accept='image/*' onChange={(e) => handleImageChange(e)} />

                        {user?.profileImg ?
                            <button className={`${styles.changeImageButton} ${styles.deleteImageButton}`} onClick={deleteImage} disabled={isDeleted || isLoading}>
                                {isDeleted ? 'Deleting...' : 'Delete Image'}
                            </button> :
                            <button className={styles.changeImageButton} onClick={() => profileImgRef.current.click()}   disabled={loading || isLoading}>
                                {loading ? 'Uploading...' : 'Upload Image'}
                            </button>
                        }
                    </div>
                </div>
            </div>
        </Myprofile>
    );
};

export default ProfileBody;
